<template>
  <div v-show="isShow()">
    <div class="wrap">
      <template v-if="isViewBackInMyProfile()">
        <div class="in-my-profile">
            <span class="me-1">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-arrow-forward-up"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M15 14l4 -4l-4 -4" /><path d="M19 10h-11a4 4 0 1 0 0 8h1" /></svg>
            </span>
          <a @click.prevent.stop="backInMyProfile()" href="#">В свой профиль</a>
          <div class="dropdown-divider"></div>
        </div>
      </template>
      <div class="title">
        Мои фантомы:
        <template v-if="isSelectPhantomProcess()">
          <span class="spinner-border spinner-sm"></span>
        </template>
      </div>
      <template v-if="hasPhantoms()">
        <div class="search mb-2 mt-2">
          <input
              v-model="searchPhantom"
              ref="searchInput"
              type="text"
              class="form-control"
              placeholder="Поиск по фантомам"
          >
        </div>
        <template v-if="hasPhantoms()">
          <div class="phantom-random">
            <div class="dropdown-divider"></div>
            <span class="me-1">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-grain"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M3.5 9.5a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" /><path d="M8.5 4.5a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" /><path d="M8.5 14.5a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" /><path d="M3.5 19.5a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" /><path d="M13.5 9.5a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" /><path d="M18.5 4.5a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" /><path d="M13.5 19.5a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" /><path d="M18.5 14.5a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" /></svg>
            </span>
            <a @click.prevent.stop="selectPhantomRandom" href="#">Случайный фантом</a>
            <div class="dropdown-divider"></div>
          </div>
        </template>
        <div :class="{'disabled-block': isSelectPhantomProcess()}" class="phantom-list">
          <template v-if="filteredPhantoms.length">
            <div
                v-for="phantom in filteredPhantoms"
                :key="phantom.id"
                @click.stop.prevent="selectPhantom(phantom.id)"
                class="dropdown-item"
            >
        <span
            class="avatar avatar-sm me-2"
            :style="'background-image: url(' + getImage(phantom.avatar.host, phantom.avatar.name, 60, 60) + ');'"
        ></span>
              {{ phantom.name }}
            </div>
          </template>

          <template v-else>
            <div class="empty-phantoms mt-1">
              По запросу ничего не найдено
            </div>
          </template>
        </div>
      </template>
      <template v-else>
        <div class="empty-phantoms">Нет фантомов</div>
      </template>
    </div>
  </div>
</template>

<script setup>
  import {onMounted, reactive, ref, watch, computed} from "vue"
  import ApiBase from "./services/ApiBase"
  import {getAll, getImage} from "./services/phantom"
  import Notify from "@/services/Notify"
  import AuthStore from "@/modules/auth/services/Store"

  const props = defineProps({
    user_id: Number,
    is_show_window: Boolean,
  })

  const searchInput = ref(null)

  let fields = reactive(getFields())
  let showProcess = ref(false)
  let selectPhantomProcess = ref(false)
  let searchPhantom = ref("")

  onMounted(async () => {
    offShowProcess()
    updateFields()
    await fetchPhantoms()
    onShowProcess()
  })

  watch(() => props.is_show_window, () => {
    searchInput.value?.focus({ preventScroll: true })
  })

  function updateFields() {
    fields.user_id = props.user_id
  }

  async function fetchPhantoms() {
    let phantoms = await getPhantoms(props.user_id)
    fields.phantoms = getAll(phantoms)
  }

  function getFields() {
    return {
      user_id: null,
      phantoms: [],
    }
  }

  function selectPhantomRandom() {
    if (fields.phantoms.length == 0) {
      return false
    }

    let rndIndex = Math.floor(Math.random() * fields.phantoms.length)
    let phantomId = fields.phantoms[rndIndex].id
    
    selectPhantom(phantomId)
  }

  async function selectPhantom(phantomId) {
    onSelectPhantomProcess()

    try {
      await ApiBase.selectPhantomToUser(phantomId, fields.user_id)

      window.location.reload()
    } catch {
      Notify.success("Ошибка при выборе фантома")
    } finally {
      //offSelectPhantomProcess()
    }
  }

  function isShow() {
    return showProcess.value
  }

  function hasPhantoms() {
    return fields.phantoms.length > 0
  }

  async function getPhantoms(id) {
    let phantoms = await ApiBase.getPhantomsToUser(id)
    let items = phantoms?.data?.item

    if (!items) {
      throw new Error("Ошибка при получении фантомов к пользователю")
    }

    return items
  }

  function onShowProcess() {
    showProcess.value = true
  }

  function offShowProcess() {
    showProcess.value = false
  }

  function onSelectPhantomProcess() {
    selectPhantomProcess.value = true
  }

  /*function offSelectPhantomProcess() {
    selectPhantomProcess.value = false
  }*/

  function isSelectPhantomProcess() {
    return selectPhantomProcess.value
  }

  async function backInMyProfile() {
    onSelectPhantomProcess()

    try {
      let data = AuthStore.getUserData()
      let userSourceId = data?.user_source_id

      await ApiBase.selectPhantomToUser(0, userSourceId)

      window.location.reload()
    } finally {
      //offSelectPhantomProcess()
    }
  }

  function isViewBackInMyProfile() {
    let data = AuthStore.getUserData()
    let userId = data?.id
    let userSourceId = data?.user_source_id

    return userId !== userSourceId
  }

  let filteredPhantoms = computed(() => {
    let query  = searchPhantom.value.trim().toLowerCase()

    if (!query) {
      return fields.phantoms
    }

    return fields.phantoms.filter((phantom) => {
      return phantom.name?.toLowerCase().includes(query)
    })
  })
</script>

<style scoped src="./css/style.css"></style>
